import { accessTokenKey, refreshExpiresInKey, refreshTokenKey } from '../../helpers/local-storage';
import { baseFetch } from './utils.ts/base-fetch';

export interface LoginRequest {
  login: string;
  password: string;
}

interface LoginResponse {
  status: boolean;
  url: string;
  data: {
    access_token: string;
    refresh_token: string;
    expires_in: number;
    is_admin?: boolean;
  };
}

const baseUrl = '/auth';

export const login = async (req: Partial<LoginRequest>): Promise<LoginResponse> => {
  const response: LoginResponse = await baseFetch(baseUrl + '/manager/login', {
    method: 'POST',
    body: JSON.stringify(req),
  });

  const { access_token, refresh_token, expires_in } = response.data;
  localStorage.setItem(accessTokenKey, access_token);
  localStorage.setItem(refreshTokenKey, refresh_token);
  localStorage.setItem(refreshExpiresInKey, expires_in.toString());

  return response;
};

export const logout = async (): Promise<void> => {
  const response = await baseFetch(baseUrl + '/manager/logout-api', {
    method: 'POST',
  });
  return response;
};

export interface RestoreRequest {
  email: string;
}

export const restore = async (req: Partial<RestoreRequest>): Promise<void> => {
  const response = await baseFetch(baseUrl + '/restore', {
    method: 'POST',
    body: JSON.stringify(req),
  });
  return response;
};

export interface ChangePasswordRequest {
  login: string;
  password: string;
  old_password: string;
  key?: string;
}

export const changePassword = async (req: Partial<ChangePasswordRequest>): Promise<void> => {
  const response = await baseFetch(baseUrl + '/change-password', {
    method: 'POST',
    body: JSON.stringify(req),
  });
  return response;
};

export const refresh = async (): Promise<void> => {
  const refreshToken = localStorage.getItem(refreshTokenKey);

  const response: LoginResponse = await baseFetch(baseUrl + '/manager/refresh', {
    method: 'POST',
    body: JSON.stringify({ refresh_token: refreshToken }),
  });

  const { access_token, refresh_token, expires_in } = response.data;
  localStorage.setItem(accessTokenKey, access_token);
  localStorage.setItem(refreshTokenKey, refresh_token);
  localStorage.setItem(refreshExpiresInKey, expires_in.toString());
};
